'use client';

import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import { r230522SocketBunja } from '@flipster/r230522/original/socket';
import { WsV2Events } from '@flipster/r230522/original/types';
import { snackbar } from '@flipster/react/design-system/snackbar';

const alertTypeMapper = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

/**
 * https://github.prex.sh/Prex/prex-core/blob/185cfba8306af66f0b74f9a9fc8082ad2a9498d1/rust/websocket-data/src/types/alert.rs#L14-L29
 * pub struct Alert {
 *     #[serde(rename = "t")]
 *     pub timestamp: Timestamp,
 *     #[serde(rename = "c")]
 *     pub code: i32,
 *     #[serde(rename = "m")]
 *     pub message: String,
 *     #[serde(rename = "i")]
 *     pub id: uuid::Uuid,
 *     #[serde(rename = "l")]
 *     pub landing_location_identifier: String, // 앱과 웹의 링크가 달라 일단 사용하지 않기로
 *     #[serde(rename = "v")] deprecated
 *     pub icon_url: String,
 *    #[serde(rename = "y")]
 *     pub r#type: AlertType,
 *     #[serde(rename = "b")]
 *     pub button_title: String,
 * }
 */
export const serverNotificationBunja = bunja(() => {
  const { r230522Events } = bunja.use(r230522SocketBunja);
  const handler = (events: WsV2Events['private/alerts']) => {
    events.forEach((event) => {
      snackbar[alertTypeMapper[event.y ?? 'SUCCESS']]({ message: event.m });
    });
  };

  bunja.effect(() => {
    r230522Events.on('private/alerts', handler);
    return () => {
      r230522Events.off('private/alerts', handler);
    };
  });

  return {};
});
serverNotificationBunja.debugLabel = 'serverNotificationBunja';

export const UseServerNotification = () => {
  useBunja(serverNotificationBunja);

  return null;
};
